import { Injectable } from '@angular/core';

// Impression d'un BL partagée par la fenêtre des livraisons (F2) et celle de la location : iframe caché, jamais de nouvelle fenêtre.
@Injectable({ providedIn: 'root' })
export class DeliveryPrintService {

	// BL rendu en PDF par le serveur (seul porteur du pied paginé « Page 2 / 3 »).
	printPdfBase64(pdfBase64: string): void {
		const octets = Uint8Array.from(atob(pdfBase64), (c) => c.charCodeAt(0));
		this.printPdfBlob(new Blob([octets], { type: 'application/pdf' }));
	}

	// PDF d'archivage d'un BL signé (GET /deliveries/:id/signed-bl).
	printPdfBlob(blob: Blob): void {
		const pdfBlob = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
		const pdfUrl = URL.createObjectURL(pdfBlob);
		this.printInHiddenIframe((iframe) => { iframe.src = pdfUrl; }, () => URL.revokeObjectURL(pdfUrl));
	}

	// Repli : BL rendu en HTML (pied non paginé) quand Gotenberg n'a pas répondu.
	printHtml(html: string): void {
		this.printInHiddenIframe((iframe) => { iframe.srcdoc = html; });
	}

	// Réponse de l'event d'impression : PDF d'abord, HTML en repli ; faux = rien à imprimer.
	printRendered(data: { pdf_base64?: string; html?: string } | null | undefined): boolean {
		if (data?.pdf_base64) { this.printPdfBase64(data.pdf_base64); return true; }
		if (data?.html) { this.printHtml(data.html); return true; }
		return false;
	}

	private printInHiddenIframe(setSource: (iframe: HTMLIFrameElement) => void, onCleanup?: () => void): void {
		const iframe = document.createElement('iframe');
		iframe.setAttribute('aria-hidden', 'true');
		// Hors écran mais à la taille d'un A4 (~96 dpi) : sinon le lecteur PDF de Chrome ne s'initialise pas et print() reste sans effet.
		iframe.style.cssText = 'position:fixed; left:-10000px; top:0; width:794px; height:1123px; border:0;';

		let removed = false;
		const cleanup = () => { if (!removed) { removed = true; iframe.remove(); onCleanup?.(); } };

		iframe.onload = () => {
			const win = iframe.contentWindow;
			if (!win) { cleanup(); return; }
			win.addEventListener('afterprint', cleanup);   // retire l'iframe une fois l'impression terminée/annulée
			setTimeout(() => { win.focus(); win.print(); }, 50);
			setTimeout(cleanup, 60000);                    // filet de sécurité si 'afterprint' ne se déclenche pas
		};

		setSource(iframe);
		document.body.appendChild(iframe);
	}
}
